import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { Logo } from "./Logo";
import { NAV, SITE, TEL } from "../../lib/site";

export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 12);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow] duration-300 ${scrolled || open ? "bg-white/85 shadow-[0_1px_0_rgba(15,43,142,0.08)] backdrop-blur-xl backdrop-saturate-150" : "bg-white/80 backdrop-blur-xl"}`}>
      <div className="mx-auto flex h-[72px] max-w-[1320px] items-center justify-between gap-4 px-5 lg:px-8">
        <Link to="/" aria-label="Accueil A+GLASS Pare-Brise HAGUENAU" data-testid="header-logo-link"><Logo /></Link>
        <nav className="hidden items-center gap-1 xl:flex" aria-label="Navigation principale">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.to.slice(1)}`} className={({ isActive }) => `nav-link ${isActive ? "text-ag-blue" : ""}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={TEL} className="btn btn-ghost hidden sm:inline-flex" data-testid="header-call-button"><Phone className="h-4 w-4" />{SITE.phone}</a>
          <Link to="/devis" className="btn btn-blue hidden md:inline-flex" data-testid="header-quote-button">Devis</Link>
          <button onClick={() => setOpen((v) => !v)} className="grid h-11 w-11 place-items-center rounded-full bg-ag-ink text-white xl:hidden" aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} aria-expanded={open} data-testid="mobile-menu-toggle">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }} className="overflow-hidden border-t border-slate-200/70 xl:hidden" aria-label="Menu mobile" data-testid="mobile-menu">
            <div className="mx-auto grid max-w-[1320px] gap-1 px-5 py-5">
              {[...NAV, { to: "/a-propos", label: "À propos" }, { to: "/faq", label: "FAQ" }, { to: "/blog", label: "Blog" }, { to: "/contact", label: "Contact" }].map((n) => (
                <NavLink key={n.to} to={n.to} className="rounded-xl px-3 py-3 font-display text-lg font-bold text-ag-ink hover:bg-ag-mist" data-testid={`mobile-nav-${n.to.slice(1)}`}>{n.label}</NavLink>
              ))}
              <Link to="/devis" className="btn btn-blue mt-3 justify-center" data-testid="mobile-menu-quote-button">Demander un devis</Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
